import React from "react";
import { createPortal } from "react-dom";
import "./AddToCartMessagePopup.scss";

// Helper to check if we're running in a browser environment
const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

const AddToCartMessagePopup = ({ message, type }) => {
  const element = (
    <div className={`add-to-cart-message-popup add-to-cart-message-popup--${type}`}>
      {message}
    </div>
  );

  // Na serwerze renderujemy null, a na kliencie portal
  if (!isBrowser) return null;
  return createPortal(element, document.body);
};

export default AddToCartMessagePopup;
